import { Skeleton } from 'antd';

// Custom data source to show skeletons inside table rows
const skeletonData = Array.from({ length: 10 }, (_, index) => ({
  index: <Skeleton active title={false} paragraph={{ rows: 1, width: "10%" }} />,
  title: <Skeleton active title={false} paragraph={{ rows: 1, width: "50%" }} />,
  slug:<Skeleton active title={false} paragraph={{ rows: 1, width: "50%" }} />,
  type:<Skeleton active title={false} paragraph={{ rows: 1, width: "50%" }} />,
  bannerImage: <Skeleton.Button active shape="square" />,
  shortContent: <Skeleton.Button active shape="square" />,
  content: <Skeleton.Button active shape="square" />,
  action: <Skeleton.Button active shape="circle" />,
}));

// Exporting the skeletonData
export { skeletonData };
